"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ThemeSwatch_1 = require("./ThemeSwatch");
var commitThemeChange_1 = require("../orchestration/commitThemeChange");
var toggleThemeQuickOptionExpansion_1 = require("../data/mutators/toggleThemeQuickOptionExpansion");
var store_1 = require("../data/store/store");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var getAvailableThemeIds_1 = require("../utils/getAvailableThemeIds");
var normalizeThemeId_1 = require("owa-theme/lib/utils/normalizeThemeId");
var React = require("react");
var styles = require('./Theme.scss');
var COLLAPSED_SIZE = 5;
var ThemeQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeQuick, _super);
    function ThemeQuick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeQuick.prototype.componentWillMount = function () {
        // Pin the initially selected theme to the front of the list for as long as this control is mounted
        this.pinnedTheme = normalizeThemeId_1.default(owa_session_store_1.getUserConfiguration().UserOptions.ThemeStorageId);
    };
    ThemeQuick.prototype.componentDidMount = function () {
        toggleThemeQuickOptionExpansion_1.default(false);
    };
    ThemeQuick.prototype.render = function () {
        var _this = this;
        var isExpanded = store_1.default().isQuickOptionExpanded;
        var themeIds = getAvailableThemeIds_1.default();
        // Push the initially saved theme to the front of the list
        var pinnedThemeIndex = themeIds.indexOf(this.pinnedTheme);
        themeIds.splice(pinnedThemeIndex, 1);
        themeIds.unshift(this.pinnedTheme);
        if (!isExpanded) {
            themeIds = themeIds.slice(0, COLLAPSED_SIZE);
        }
        return (React.createElement("div", { className: styles.quickContainer },
            React.createElement(FocusZone_1.FocusZone, { className: styles.swatchContainer, role: "listbox" }, themeIds.map(function (id) { return (React.createElement(ThemeSwatch_1.default, { themeId: id, onClick: _this.onThemeClick, key: id })); })),
            React.createElement(Button_1.CommandButton, { text: isExpanded ? owa_options_strings_1.default.themeCollapseLabel : owa_options_strings_1.default.themeExpandLabel, onClick: this.toggleExpand, className: styles.expandButton })));
    };
    ThemeQuick.prototype.toggleExpand = function () {
        toggleThemeQuickOptionExpansion_1.default();
    };
    ThemeQuick.prototype.onThemeClick = function (themeId) {
        commitThemeChange_1.commitQuickThemeChange(themeId);
    };
    ThemeQuick = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeQuick);
    return ThemeQuick;
}(React.Component));
exports.default = ThemeQuick;
//# sourceMappingURL=ThemeQuick.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/view/ThemeQuick.js
// module id = 4965
// module chunks = 2